export default "__VITE_ASSET__kxGjifqt__"